import type { FC } from "react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { useMutation } from "@apollo/client"

import styles from "./CompanyCreatePage.module.scss"

import { graphql } from "@/souhl_admin/gql/__generated__/gql"

const CreateCompany = graphql(/* GraphQL */ `
	mutation CreateCompany($input: CreateCompanyInput!) {
		createCompany(input: $input) {
			company {
				id
				name
			}
		}
	}
`)

const CreateDefaultRule = graphql(/* GraphQL */ `
	mutation CreateDefaultCompanySmsSendingRuleV2(
		$input: CreateDefaultCompanySmsSendingRuleV2Input!
	) {
		createDefaultCompanySmsSendingRuleV2(input: $input) {
			companyId
		}
	}
`)

const CompanyCreatePage: FC = () => {
	const navigate = useNavigate()
	const [name, setName] = useState("")
	const [errors, setErrors] = useState<{ name?: string }>({})

	const [createDefaultRule] = useMutation(CreateDefaultRule)

	const [createCompany, { loading }] = useMutation(CreateCompany, {
		onCompleted: async (data) => {
			if (
				data?.createCompany?.company?.id &&
				data?.createCompany?.company?.name
			) {
				const companyId = data.createCompany.company.id
				const companyName = data.createCompany.company.name

				try {
					// デフォルトルールを作成
					await createDefaultRule({
						variables: {
							input: {
								companyId,
								companyName,
							},
						},
					})
					console.log("デフォルトルールを作成しました")
				} catch (error) {
					console.error("Failed to create default rule:", error)
					// デフォルトルール作成に失敗してもエラーは表示せず、詳細画面に遷移
				}

				// 作成成功後、詳細画面に遷移
				navigate(`/souhl_admin/companies/${companyId}`)
			}
		},
		onError: (error) => {
			console.error("Failed to create company:", error)
		},
	})

	const validateForm = () => {
		const newErrors: { name?: string } = {}

		if (!name.trim()) {
			newErrors.name = "名前は必須です"
		}

		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleSubmit = async () => {
		if (!validateForm()) {
			return
		}

		await createCompany({
			variables: {
				input: {
					name: name.trim(),
				},
			},
		})
	}

	const handleCancel = () => {
		navigate("/souhl_admin")
	}

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<h1 className={styles.title}>会社作成</h1>
				<div className={styles.actions}>
					<button
						className={styles.cancelButton}
						onClick={handleCancel}
						disabled={loading}
					>
						キャンセル
					</button>
					<button
						className={styles.createButton}
						onClick={handleSubmit}
						disabled={loading}
					>
						{loading ? "作成中..." : "作成"}
					</button>
				</div>
			</div>

			<div className={styles.formContainer}>
				<div className={styles.formHeader}>
					<h2 className={styles.formTitle}>会社情報</h2>
				</div>

				<div className={styles.formContent}>
					<div className={styles.formField}>
						<label className={styles.label}>名前</label>
						<div className={styles.inputWrapper}>
							<input
								type="text"
								className={`${styles.input} ${errors.name ? styles.error : ""}`}
								value={name}
								onChange={(e) => setName(e.target.value)}
								placeholder="株式会社SOUHL"
								disabled={loading}
							/>
							{errors.name && (
								<span className={styles.errorMessage}>{errors.name}</span>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CompanyCreatePage
